import { ApiService } from '../../../service/api.service'

const apiService = new ApiService()

export const forgotApi = async (type, data, token) => {
    let url;
    let result;
    if (type === "reset-password") {
        url = `resetPassword/${token}`
    } else {
        url = "forgotPassword"
    }
    try {
        const response = await apiService.post(`api/v1/ekutir/user/auth/${url}`, data)
        if (response) {
            result = response;
        }
    } catch (error) {
        result = error;
    }
    return result;
}